import React from 'react';
import { Avatar } from 'material-ui';
import authHelper from 'helpers/auth';
import theme from 'theme/theme';

const avatarStyle = {
    cursor: 'pointer',
    fontSize: '14px',
};

const UserAvatar = () => {
    return (
        <Avatar color='white' backgroundColor={ theme.palette.primary1Color } style={ avatarStyle } alt='User' size={ 35 }>
            { authHelper.getUserNameInitials() }
        </Avatar>
    );
};

export default UserAvatar;


// WEBPACK FOOTER //
// ./src/components/ui/general/UserAvatar.js